import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import {
    FieldRow,
    ExpandColumn,
} from 'v-c/Forms/InputGroup';

// TODO: move this component to Insights
export default function Row(props) {
    return (
        <FieldRow>
            <ExpandColumn>
                {props.children}
            </ExpandColumn>
        </FieldRow>
    );
}

Row.displayName = displayName('CompositeComponents/Forms/Row');

Row.propTypes = {
    children: PropTypes.node.isRequired,
};
